export const getPagination = (slug: string) => ({
  pageSize: +localStorage.getItem(`${slug}PageSize`)! || 20,
  currentPage: 0,
})
